<template>
  <div class="internal_class">
    <el-divider content-position="left">内训学院课程表</el-divider>
    <el-row></el-row>
    <el-row class="mb-10">
      <el-col :span="24" class="tr">
        <el-button size="mini" type="primary" @click="handleOpenInternal"
          >入口图片替换</el-button
        >
        <el-button size="mini" type="primary" @click="handleAddOpen">新增课程</el-button>
      </el-col>
    </el-row>

    <el-table
    height="calc(100vh - 266px)"
      :data="totalData"
      size="medium"
      style="width: 100%; margin-top: 0.2rem"
      v-cloak
      border
    >
      <el-table-column
        v-for="(item, index) in col"
        :key="index"
        :label="item.label"
        :prop="item.prop"
      >
        <template slot-scope="scope">
          <el-tooltip
            v-if="item.prop === 'content'"
            :content="scope.row.content"
            placement="top"
          >
            <span class="count_style">{{ scope.row[item.prop] }}</span>
          </el-tooltip>
          <el-tooltip
            v-else-if="item.prop === 'title'"
            :content="scope.row.title"
            placement="top"
          >
            <span class="count_style">{{ scope.row[item.prop] }}</span>
          </el-tooltip>
          <el-tooltip
            v-else-if="item.prop === 'class_place'"
            :content="scope.row.class_place"
            placement="top"
          >
            <span class="count_style">{{ scope.row[item.prop] }}</span>
          </el-tooltip>

          <span v-else-if="item.prop === 'created_at'">
            <date-formatter :date-value="scope.row[item.prop]"></date-formatter>
          </span>
          <span v-else-if="item.prop === 'class_start_at'">
            <date-formatter :date-value="scope.row[item.prop]"></date-formatter>
          </span>
          <span v-else-if="item.prop === 'class_end_at'">
            <date-formatter :date-value="scope.row[item.prop]"></date-formatter>
          </span>
          <span v-else-if="item.prop === 'register_end_at'">
            <date-formatter :date-value="scope.row[item.prop]"></date-formatter>
          </span>

          <span v-else class="count_style">{{ scope.row[item.prop] }}</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="编辑课程信息" placement="top">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-edit"
              @click="handleInternalOpen(scope.$index, scope.row)"
              circle
            ></el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="报名签到人员信息"
            placement="top"
          >
            <el-button
              type="success"
              size="mini"
              icon="el-icon-reading"
              @click="handleGetSignIn(scope.row)"
              circle
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>


    <div class="page-footer">
    <el-pagination
      background
      class="pagination-style"
      layout="sizes, total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-sizes="[10, 20, 30, 50, 100, 500]"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    </div>
    <el-drawer title="添加" :visible.sync="addDrawer" direction="rtl" size="40%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <div class="tabs_line">
          <div class="lines"></div>
          <h3 class="tabs-title">课程基础信息</h3>
        </div>
        <el-divider></el-divider>
        <el-row>
          <el-col :span="4" class="m-label">课程标题：</el-col>
          <el-col :span="18" class="m-label">
            <el-input v-model="addData.title" :size="inputSize" clearable></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="m-label">课程内容：</el-col>
          <el-col :span="18">
            <el-input
              type="textarea"
              :autosize="textareaSize2"
              v-model="addData.content"
              clearable
            ></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="m-label">起始时间：</el-col>
          <el-col :span="18">
            <el-date-picker
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="startEndTime"
              :size="inputSize"
              @change="getStartEndTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="m-label">课程地点：</el-col>
          <el-col :span="18" class="m-label">
            <el-input
              v-model="addData.class_place"
              :size="inputSize"
              clearable
            ></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="m-label">纬度（lat）：</el-col>
          <el-col :span="18" class="m-label">
            <el-input v-model="addData.lat" :size="inputSize" clearable></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="m-label">经度（lng）：</el-col>
          <el-col :span="18" class="m-label">
            <el-input v-model="addData.lng" :size="inputSize" clearable></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="m-label">截至报名：</el-col>
          <el-col :span="18">
            <el-date-picker
              v-model="addData.register_end_at"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间"
              :size="inputSize"
              default-time="12:00:00"
            >
            </el-date-picker>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="m-label">课程图片：</el-col>
          <el-col :span="18" class="m-label">
            <el-upload
              class="upload-demo"
              :headers="uploadHeader"
              :action="actionHost + '/api/article/internal/add'"
              :on-remove="handleRemove"
              :file-list="materialFileList1"
              list-type="picture"
              :on-success="handleAddCoverSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <el-button v-if="!addCoverUrl" size="mini" type="primary"
                >点击上传</el-button
              >
              <div slot="tip" v-if="false" class="el-upload__tip">
                只能上传jpg/png文件，且不超过500kb
              </div>
            </el-upload>
          </el-col>
        </el-row>
        <el-row class="mt-10 tr">
          <el-button type="primary" :size="inputSize" @click="handleAddSave"
            >添加</el-button
          >
        </el-row>
      </div>
    </el-drawer>
    <el-drawer
      title="修改"
      :visible.sync="upDrawer"
      direction="rtl"
      :before-close="handleAddBeforeClose"
      size="40%"
    >
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <div class="tabs_line">
          <div class="lines"></div>
          <h3 class="tabs-title">课程基础信息</h3>
        </div>
        <el-divider></el-divider>
        <el-row>
          <el-col :span="4" class="m-label">课程标题：</el-col>
          <el-col :span="18" class="m-label">
            <el-input
              v-model="upData.title"
              :size="inputSize"
              @change="updateInternalData('title')"
              clearable
            ></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="m-label">课程内容：</el-col>
          <el-col :span="18">
            <el-input
              type="textarea"
              :autosize="textareaSize2"
              v-model="upData.content"
              @change="updateInternalData('content')"
              clearable
            ></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="m-label">起始时间：</el-col>
          <el-col :span="18">
            <el-date-picker
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="startEndTime"
              :size="inputSize"
              @change="updateInternalData('startEndTime')"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="m-label">课程地点：</el-col>
          <el-col :span="18" class="m-label">
            <el-input
              v-model="upData.class_place"
              :size="inputSize"
              @change="updateInternalData('class_place')"
              clearable
            ></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="m-label">纬度（lat）：</el-col>
          <el-col :span="18" class="m-label">
            <el-input
              v-model="upData.lat"
              :size="inputSize"
              @change="updateInternalData('lat')"
              clearable
            ></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="m-label">经度（lng）：</el-col>
          <el-col :span="18" class="m-label">
            <el-input
              v-model="upData.lng"
              :size="inputSize"
              @change="updateInternalData('lng')"
              clearable
            ></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="m-label">截至报名：</el-col>
          <el-col :span="18">
            <el-date-picker
              v-model="upData.register_end_at"
              type="datetime"
              :size="inputSize"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间"
              default-time="12:00:00"
              @change="updateInternalData('register_end_at')"
              clearable
            >
            </el-date-picker>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="m-label">课程图片：</el-col>
          <el-col :span="18" class="m-label">
            <el-upload
              class="upload-demo"
              :headers="uploadHeader"
              :action="actionHost + '/api/article/internal/add'"
              :on-preview="handleSavePictureCardPreview"
              :on-remove="handleSaveRemove"
              :file-list="materialFileListSave"
              list-type="picture"
              :on-success="handleSaveCoverSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <el-button v-if="!editCoverUrl" size="mini" type="primary"
                >点击上传</el-button
              >
              <div slot="tip" v-if="false" class="el-upload__tip">
                只能上传jpg/png文件，且不超过500kb
              </div>
            </el-upload>
          </el-col>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer title="报名签到" :visible.sync="signDrawer" direction="rtl" size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <div class="tabs_line">
          <div class="lines"></div>
          <h3 class="tabs-title">报名签到信息</h3>
        </div>
        <el-divider></el-divider>
        <el-table
          :data="signData"
          size="medium"
          style="width: 100%; margin-top: 0.2rem"
          v-cloak
        >
          <el-table-column label="学员姓名" prop="users.username"></el-table-column>
          <el-table-column label="报名时间" prop="created_at"></el-table-column>
          <el-table-column label="签到时间" prop="sign_at"></el-table-column>
        </el-table>
      </div>
    </el-drawer>
    <el-dialog :visible.sync="dialogVisible3" class="el_dialogs" width="45%">
      <div class="box_title" style="margin-bottom: 0.2rem">
        <el-row>
          <el-col :span="8">
            <span style="font-size: 12px">&nbsp;&nbsp;内训学院入口图片上传替换：</span>
          </el-col>
          <el-col :span="8">
            <el-upload
              :action="actionHost + '/api/upload/internal'"
              :headers="uploadHeader"
              accept=".png,.jpg"
              :show-file-list="false"
              :on-success="handleMaterialSuccess"
              :on-preview="handleMaterialPreview"
              :on-remove="handleMaterialRemove"
              :file-list="materialFlieList"
            >
              <el-link type="primary">点击上传</el-link>
            </el-upload>
          </el-col>
        </el-row>
      </div>
      <div class="dialog_box dialog_img" v-if="pic_url">
        <img width="100%" height="100%" :src="pic_url" />
      </div>
      <span slot="footer" class="dialog-footer"></span>
    </el-dialog>
  </div>
</template>
<script>
import DateFormatter from "common/DateFormatter";
export default {
  name: "internal_class",
  components: { DateFormatter },
  data() {
    return {
      inputSize: "small",
      pic_url: "",
      totalData: [],
      startEndTime: [],
      signData: [],
      materialFlieList: [],
      materialFileList1: [],
      editCoverUrl: "",
      materialFileListSave: [],
      addDrawer: false,
      upDrawer: false,
      signDrawer: false,
      dialogVisible3: false,
      imgPath: this.$store.state.imgPath,
      addCoverUrl: "",
      uploadHeader: {
        Authorization: localStorage.token,
      },
      addData: {
        title: "",
        content: "",
        class_start_at: "",
        class_end_at: "",
        register_end_at: "",
        class_place: "",
        class_image: "",
        lat: "",
        lng: "",
      },
      upData: {
        id: "",
        title: "",
        content: "",
        class_start_at: "",
        class_end_at: "",
        register_end_at: "",
        class_place: "",
        class_image: "",
        lat: "",
        lng: "",
      },
      textareaSize2: {
        minRows: 2,
        maxRows: 4,
      },
      col: [
        {
          label: "课程标题",
          prop: "title",
          display: false,
        },
        {
          label: "课程地址",
          prop: "class_place",
          display: false,
        },
        {
          label: "发布时间",
          prop: "created_at",
          display: false,
        },
        {
          label: "课程开始时间",
          prop: "class_start_at",
          display: false,
        },
        {
          label: "课程结束时间",
          prop: "class_end_at",
          display: false,
        },
        {
          label: "报名截止时间",
          prop: "register_end_at",
          display: false,
        },
        {
          label: "详细描述",
          prop: "content",
          display: false,
        },
      ],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1, // 搜索后页码
        pageSize: 30, // 每页显示条数
      },
    };
  },
  computed: {
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === "development" ? "" : "https://weixin.qiyehuo.com";
      },
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  watch: {},
  methods: {
    handelGetInternal() {
      this.$axios
        .get("/api/internal_class?page=" + this.pageOption.currentPage)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.totalData = data.data.list.data;
            this.pic_url = this.actionHost + "/storage/" + data.data.pic_url;
            this.pageOption.total = data.data.list.total;
            this.pageOption.currentPage = data.data.list.current_page;
          }
        });
    },
    handleAddSave() {
      if (!this.addData.title) {
        this.$message.error("课程标题不能为空");
        return;
      }
      if (!this.addData.class_place) {
        this.$message.error("课程地址不能为空");
        return;
      }
      if (!this.addData.lat) {
        this.$message.error("地址纬度不能为空");
        return;
      }
      if (!this.addData.lng) {
        this.$message.error("地址经度不能为空");
        return;
      }
      if (!this.addData.register_end_at) {
        this.$message.error("截至报名时间不能为空");
        return;
      }
      this.$axios
        .post("/api/internal_class?page=" + this.pageOption.currentPage, this.addData)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.handelGetInternal();
            this.clearAddData();
          }
        });
    },
    updateInternalData(field) {
      let currentValue = this.upData[field];
      if (field === "startEndTime") {
        currentValue = this.startEndTime;
      }
      this.$axios
        .put("/api/internal_class/" + this.upData.id, {
          fieldName: field,
          value: currentValue,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.handelGetInternal();
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleGetSignIn(row) {
      this.$axios.get("/api/internal_class/get_sign/" + row.id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.signData = data.data.list;
        }
      });
      this.signDrawer = true;
    },
    handleMaterialSuccess(res, file) {
      if (res.code === 0) {
        this.materialFlieList.push({
          name: file.name,
          url: this.imgPath + res.data.store_result,
        });
        for (var a = 0; this.materialFlieList.length; a++) {
          this.pic_url = this.materialFlieList[a].url;
        }
      } else {
        this.$message.error(res.msg);
      }
    },
    handleMaterialPreview(file) {
      var tempwindow = window.open("_blank");
      for (var a = 0; a < this.materialFlieList.length; a++) {
        tempwindow.location = this.materialFlieList[a].url;
      }
    },
    handleMaterialRemove(file, fileList) {
      for (var i = 0; i < this.materialFlieListSub.length; i++) {
        if (file.name === this.materialFlieListSub[i].name) {
          var fileName = this.materialFlieListSub[i].url;
          this.materialFlieList.splice(i, 1);
          this.materialFlieListSub.splice(i, 1);
          this.basicCluesData.files.splice(i, 1);
        }
      }
      this.$axios.post("/api/upload/del_img", { file_name: fileName }).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleAddCoverSuccess(res, file) {
      if (res.code === 0) {
        this.addCoverUrl = URL.createObjectURL(file.raw);
        this.materialFileList1.push({
          name: file.name,
          url: this.imgPath + res.data.store_result,
          img_name: res.data.store_result,
        });
        this.addData.class_image = res.data.store_result;
        this.addData.class_image_name = this.imgPath + res.data.store_result;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleSaveCoverSuccess(res, file) {
      if (res.code === 0) {
        this.editCoverUrl = URL.createObjectURL(file.raw);
        this.materialFileListSave.push({
          name: file.name,
          url: this.imgPath + res.data.store_result,
          img_name: res.data.store_result,
        });
        this.upData.class_image = res.data.store_result;
        this.upData.class_image_name = res.data.store_result;
        this.updateInternalData("class_image");
      } else {
        this.$message.error(res.msg);
      }
    },
    beforeAvatarUpload(file) {
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        this.$message.error("封面只能是 JPG、PNG 格式!");
        return false;
      }
      return true;
    },
    handleRemove(file) {
      if (file.name === this.materialFileList1[0].name) {
        var fileName = this.materialFileList1[0].img_name;
        this.addCoverUrl = "";
        this.addData.class_image = "";
        this.materialFileList1 = [];
      }
      this.$axios
        .post("/api/article/banner/delete", { file_name: fileName })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleSaveRemove(file) {
      if (file.name === this.materialFileListSave[0].name) {
        this.editCoverUrl = "";
        this.upData.class_image = "";
        this.materialFileListSave = [];
        this.updateInternalData("class_image");
      }
    },
    handleSavePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
    },
    handleOpenInternal() {
      this.dialogVisible3 = true;
    },
    handleInternalOpen(index, row) {
      let currentUrls = "";
      this.upData.id = row.id;
      this.upData.title = row.title;
      this.upData.content = row.content;
      this.upData.class_place = row.class_place;
      this.upData.class_image = row.class_image;
      this.upData.lat = row.lat;
      this.upData.lng = row.lng;
      this.upData.register_end_at = row.register_end_at;
      this.startEndTime = [row.class_start_at, row.class_end_at];
      this.editCoverUrl = row.class_image;
      if (row.class_image) {
        currentUrls = this.imgPath + row.class_image;
        this.materialFileListSave.push({
          name: row.class_image,
          url: currentUrls,
          img_name: this.imgPath + row.class_image,
        });
      }
      this.upDrawer = true;
    },
    clearAddData() {
      this.addData.title = "";
      this.addData.content = "";
      this.startEndTime = [];
      this.addData.class_start_at = "";
      this.addData.class_end_at = "";
      this.addData.register_end_at = "";
      this.addData.class_place = "";
      this.addData.class_image = "";
      this.addData.lat = "";
      this.addData.lng = "";
      this.materialFileList1 = [];
      this.addDrawer = false;
    },
    clearUpData() {
      this.upData.id = "";
      this.upData.title = "";
      this.upData.content = "";
      this.upData.class_place = "";
      this.upData.lat = "";
      this.upData.lng = "";
      this.upData.register_end_at = "";
      this.upData.class_image = "";
      this.startEndTime = [];
      this.materialFileListSave = [];
      this.upDrawer = false;
    },
    handleAddBeforeClose(done) {
      this.clearUpData();
      done();
    },
    getStartEndTime() {
      this.addData.class_start_at = this.startEndTime[0];
      this.addData.class_end_at = this.startEndTime[1];
    },
    handleAddOpen() {
      this.addCoverUrl = "";
      this.materialFileList1 = [];
      this.addDrawer = true;
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.handelGetInternal();
    },
  },
  mounted() {
    this.handelGetInternal();
  },
};
</script>
<style scoped lang="stylus">
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
@import '~styles/icon.styl'
[v-cloak]
  display: none
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.el-collapse
  border-bottom 0
  border-top 0
.el-collapse >>> .el-collapse-item__header
  color: #4C87FC
  font-weight bold
.el-collapse >>> .el-collapse-item__arrow
  color: #4C87FC
.el-select
  width: 100%
.internal_class >>> .el-table__header th
  color: #333333
  background-color: #ECF4FF
.internal_class
  marginLeft()
  .count_style
    display: inherit
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
.search-row .el-col
  margin-bottom: .2rem
.tr
  text-align: right
.mt-10
  margin-top: .2rem
.m-tabs-content
  padding: 0 .2rem 0 .4rem
  .m-label
    line-height: .64rem
  .el-row
    margin-bottom: .4rem
.el-date-editor
  width: 100%
.page-footer
  position: fixed;
  bottom: 0;
  left: 0;
  height: 80px;
  background: #fff;
  width: 100%;
  z-index: 2;
.pagination-style
  padding-top: 25px;
  text-align: right;
</style>



// WEBPACK FOOTER //
// src/pages/internal_class/internal_class.vue